<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { refresh } from "@/request/api";

export default {
  name: "app",
  data() {
    return {};
  },
  mounted() {

    var url = window.location.href 
    var host = window.location.origin

    console.log('url',url);
    console.log('host',host);

    //var a = url.split('#')[1]
    var b  = url.replaceAll(host + "/home/","");

    console.log(b);

    if(b && b.length >= 2 && b.substring(0,2).toLowerCase() === 'wu')
    {
      console.log(b);

      this.$router.push({
        path: "/link",
        query: { code:b },
      });
    }

    this.refreshToken();
  },
  methods: {
    // 刷新token
    refreshToken() {
      // refresh().then(res => {
      //   console.log(res, "刷新token");
      //   window.localStorage.setItem(
      //     "access_token",
      //     JSON.stringify(res.data.data.access_token)
      //   );
      // });
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

#nav {
  // padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

input {
  border: 0px !important;
  outline: none !important;
}

body,
button,
input,
select,
textarea {
  font: 12px/1.5tahoma, arial, \5b8b\4f53;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}
address,
cite,
dfn,
em,
var {
  font-style: normal;
}
code,
kbd,
pre,
samp {
  font-family: couriernew, courier, monospace;
}
small {
  font-size: 12px;
}
ul,
ol {
  // list-style: none;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
sup {
  vertical-align: text-top;
}
sub {
  vertical-align: text-bottom;
}
legend {
  color: #000;
}
fieldset,
img {
  border: 0 !important;
}

img[src=""],
img:not([src]) {
  opacity: 0;
}
button,
input,
select,
textarea {
  font-size: 100%;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  // -moz-user-select: -moz-none;
  // -moz-user-select: none;
  // -o-user-select: none;
  // -khtml-user-select: none;
  // -webkit-user-select: none;
  // -ms-user-select: none;
  // user-select: none;
  -webkit-user-select: auto; /*webkit浏览器*/
  user-select: auto;
  -o-user-select: auto;
  -ms-user-select: auto;
}
</style>
